import { VueModule } from '@Foundation/utilities';
import { footerPadding } from './code/Scripts/directives/footerPadding';

export default VueModule({
  directives: {
    footerPadding
  }
});
